<div class="home-container">
  <app-header></app-header>

  <main class="home-content">
    <section class="hero-section">
      <div class="hero-container">
        <div class="hero-content">
          <h1 class="hero-title">
            Discover Amazing Deals<br />
            <span class="hero-title-gradient">Sell What You Don't Need</span>
          </h1>

          <p class="hero-description">
            Your one-stop marketplace connecting buyers and sellers. From
            vehicles to real estate, find everything you need or turn your items
            into cash.
          </p>

          <div class="hero-search">
            <div class="hero-search-box">
              <svg viewBox="0 0 24 24" class="search-box-icon">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
              <input
                type="text"
                placeholder="Search for anything..."
                class="hero-search-input"
                #heroSearchInput
                inputmode="search"
                (keydown)="
                  onSearchKeydown(
                    $event,
                    heroSearchInput.value,
                    heroCategorySelect.value
                  )
                "
              />
              <div class="hero-search-divider"></div>
              <div class="hero-search-dropdown">
                <select class="hero-search-category" #heroCategorySelect>
                  <option value="all">All Categories</option>
                  <option value="vehicles">Vehicles</option>
                  <option value="real-estate">Real Estate</option>
                  <option value="marketplace">Marketplace</option>
                  <option value="jobs">Jobs</option>
                </select>
              </div>
              <button
                type="submit"
                class="hero-search-button"
                (click)="
                  searchListings(
                    heroSearchInput.value,
                    heroCategorySelect.value
                  )
                "
              >
                <span>Search</span>
              </button>
            </div>

            <div class="hero-quick-categories">
              <span class="quick-label">Popular:</span>
              <a (click)="searchListings('bmw', 'vehicles')" class="quick-link"
                >BMW</a
              >
              <a
                (click)="searchListings('apartment', 'real-estate')"
                class="quick-link"
                >Apartment</a
              >
              <a
                (click)="searchListings('iphone', 'marketplace')"
                class="quick-link"
                >iPhone</a
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="categories-section">
      <div class="categories-container">
        <div class="categories-grid">
          <a routerLink="/search/vehicles" class="category-card">
            <div class="category-icon-wrapper">
              <img
                src="assets/images/categoriesIcon/vehicles.png"
                alt="Vehicles"
                class="category-icon-img"
              />
            </div>
            <h3 class="category-name">Vehicles</h3>
            <p class="category-description">Cars, motorcycles & more</p>
          </a>

          <a routerLink="/search/real-estate" class="category-card">
            <div class="category-icon-wrapper">
              <img
                src="assets/images/categoriesIcon/realEstate.png"
                alt="Real Estate"
                class="category-icon-img"
              />
            </div>
            <h3 class="category-name">Real Estate</h3>
            <p class="category-description">Houses, apartments & land</p>
          </a>

          <a routerLink="/search/marketplace" class="category-card">
            <div class="category-icon-wrapper">
              <img
                src="assets/images/categoriesIcon/marketplace.png"
                alt="Marketplace"
                class="category-icon-img"
              />
            </div>
            <h3 class="category-name">Marketplace</h3>
            <p class="category-description">Electronics, furniture & more</p>
          </a>

          <a routerLink="/search/jobs" class="category-card">
            <div class="category-icon-wrapper">
              <img
                src="assets/images/categoriesIcon/jobs.png"
                alt="Jobs"
                class="category-icon-img"
              />
            </div>
            <h3 class="category-name">Jobs</h3>
            <p class="category-description">Services & opportunities</p>
          </a>
        </div>
      </div>
    </section>

    <section class="featured-listings-section">
      <div class="section-header-featured">
        <div class="section-title-wrapper">
          <h2 class="section-title-large">Featured Listings</h2>
          <p class="section-subtitle">
            Hand-picked premium listings just for you
          </p>
        </div>
      </div>

      <div *ngIf="isLoadingFeatured" class="featured-grid-loading">
        <div class="featured-hero-placeholder">
          <div class="loading-image-large"></div>
          <div class="loading-content-large">
            <div class="loading-line-xl"></div>
            <div class="loading-line-lg"></div>
            <div class="loading-line-md"></div>
          </div>
        </div>
        <div class="featured-secondary-grid">
          <div
            class="listing-card-featured loading-placeholder"
            *ngFor="let i of [1, 2, 3, 4]"
          >
            <div class="listing-image-placeholder"></div>
            <div class="listing-content">
              <div class="loading-line loading-title"></div>
              <div class="loading-line loading-price"></div>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="!isLoadingFeatured && featuredListings.length > 0"
        class="featured-grid-layout"
      >
        <div
          class="featured-hero-card"
          (mouseenter)="onListingHover(featuredListings[0])"
          (mouseleave)="onListingLeave(featuredListings[0])"
        >
          <div
            class="featured-hero-image-container"
            (touchstart)="onTouchStart($event, featuredListings[0])"
            (touchmove)="onTouchMove($event, featuredListings[0])"
            (touchend)="onTouchEnd($event, featuredListings[0])"
          >
            <div
              class="image-wrapper"
              [class.loading]="featuredListings[0].isImageLoading"
            >
              <img
                [src]="featuredListings[0].image"
                [alt]="featuredListings[0].title"
                class="featured-hero-image"
                loading="lazy"
                (load)="
                  onImageLoad(featuredListings[0].image, featuredListings[0])
                "
                (error)="
                  featuredListings[0].image =
                    '/assets/images/listing-placeholder/no-image-placeholder.png'
                "
              />
              <div class="hero-image-overlay"></div>

              <div
                class="image-loading-overlay"
                *ngIf="featuredListings[0].isImageLoading"
              >
                <div class="spinner"></div>
              </div>
            </div>

            <div
              class="image-click-zones desktop-only"
              *ngIf="hasMultipleImages(featuredListings[0])"
            >
              <div
                class="click-zone zone-left"
                (click)="onImageZoneClick($event, featuredListings[0], 'prev')"
                [attr.aria-label]="'Previous image'"
              >
                <div class="zone-icon">
                  <svg viewBox="0 0 24 24" class="zone-svg">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </div>
              </div>
              <div
                class="click-zone zone-middle"
                (click)="onImageZoneClick($event, featuredListings[0], 'view')"
              ></div>
              <div
                class="click-zone zone-right"
                (click)="onImageZoneClick($event, featuredListings[0], 'next')"
                [attr.aria-label]="'Next image'"
              >
                <div class="zone-icon">
                  <svg viewBox="0 0 24 24" class="zone-svg">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </div>
              </div>
            </div>

            <div
              class="carousel-controls hero-carousel desktop-only"
              *ngIf="
                hasMultipleImages(featuredListings[0]) &&
                featuredListings[0].showCarouselControls
              "
              [class.fading-out]="!featuredListings[0].showCarouselControls"
            >
              <div class="carousel-indicator">
                <svg viewBox="0 0 24 24" class="carousel-icon">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </div>

              <div class="carousel-indicator">
                <svg viewBox="0 0 24 24" class="carousel-icon">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </div>

            <div
              class="image-counter hero-counter desktop-only"
              *ngIf="hasMultipleImages(featuredListings[0])"
            >
              {{ getImageCounter(featuredListings[0]) }}
            </div>

            <div
              class="image-dots mobile-only"
              *ngIf="hasMultipleImages(featuredListings[0])"
            >
              <span
                *ngFor="let img of featuredListings[0].images; let i = index"
                class="dot"
                [class.active]="i === featuredListings[0].currentImageIndex"
              ></span>
            </div>
          </div>

          <div
            class="featured-hero-content"
            (click)="onListingClick(featuredListings[0])"
            (touchstart)="onListingTouchStart($event, featuredListings[0])"
            (touchmove)="onListingTouchMove($event, featuredListings[0])"
            (touchend)="onListingTouchEnd($event, featuredListings[0])"
          >
            <h3 class="featured-hero-title">{{ featuredListings[0].title }}</h3>
            <div class="featured-hero-price">
              <span class="price-amount"
                >{{ featuredListings[0].currency || "€" }}
                {{ featuredListings[0].price | number : "1.0-0" }}</span
              >
            </div>
            <div class="featured-hero-details">
              <div class="detail-item">
                <svg viewBox="0 0 24 24" class="detail-icon">
                  <path
                    d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                  ></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span>{{ featuredListings[0].location }}</span>
              </div>
              <div class="detail-item" *ngIf="featuredListings[0].view_count">
                <svg viewBox="0 0 24 24" class="detail-icon">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <span>{{ featuredListings[0].view_count }} views</span>
              </div>
            </div>
          </div>
        </div>

        <div class="featured-secondary-grid">
          <div
            *ngFor="let listing of featuredListings.slice(1, 5)"
            class="listing-card-featured"
            (mouseenter)="onListingHover(listing)"
            (mouseleave)="onListingLeave(listing)"
          >
            <div
              class="listing-image-container-featured"
              (touchstart)="onTouchStart($event, listing)"
              (touchmove)="onTouchMove($event, listing)"
              (touchend)="onTouchEnd($event, listing)"
            >
              <div
                class="image-wrapper"
                [class.loading]="listing.isImageLoading"
              >
                <img
                  [src]="listing.image"
                  [alt]="listing.title"
                  class="listing-image-featured"
                  loading="lazy"
                  (load)="onImageLoad(listing.image, listing)"
                  (error)="
                    listing.image =
                      '/assets/images/listing-placeholder/no-image-placeholder.png'
                  "
                />
                <div class="featured-image-overlay"></div>

                <div
                  class="image-loading-overlay"
                  *ngIf="listing.isImageLoading"
                >
                  <div class="spinner"></div>
                </div>
              </div>

              <div
                class="image-click-zones desktop-only"
                *ngIf="hasMultipleImages(listing)"
              >
                <div
                  class="click-zone zone-left"
                  (click)="onImageZoneClick($event, listing, 'prev')"
                  [attr.aria-label]="'Previous image'"
                >
                  <div class="zone-icon">
                    <svg viewBox="0 0 24 24" class="zone-svg">
                      <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                  </div>
                </div>
                <div
                  class="click-zone zone-middle"
                  (click)="onImageZoneClick($event, listing, 'view')"
                ></div>
                <div
                  class="click-zone zone-right"
                  (click)="onImageZoneClick($event, listing, 'next')"
                  [attr.aria-label]="'Next image'"
                >
                  <div class="zone-icon">
                    <svg viewBox="0 0 24 24" class="zone-svg">
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </div>
                </div>
              </div>

              <div
                class="carousel-controls desktop-only"
                *ngIf="
                  hasMultipleImages(listing) && listing.showCarouselControls
                "
                [class.fading-out]="!listing.showCarouselControls"
              >
                <div class="carousel-indicator">
                  <svg viewBox="0 0 24 24" class="carousel-icon">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </div>

                <div class="carousel-indicator">
                  <svg viewBox="0 0 24 24" class="carousel-icon">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </div>
              </div>

              <div
                class="image-counter desktop-only"
                *ngIf="hasMultipleImages(listing)"
              >
                {{ getImageCounter(listing) }}
              </div>

              <div
                class="image-dots mobile-only"
                *ngIf="hasMultipleImages(listing)"
              >
                <span
                  *ngFor="let img of listing.images; let i = index"
                  class="dot"
                  [class.active]="i === listing.currentImageIndex"
                ></span>
              </div>
            </div>

            <div
              class="listing-content-featured"
              (click)="onListingClick(listing)"
              (touchstart)="onListingTouchStart($event, listing)"
              (touchmove)="onListingTouchMove($event, listing)"
              (touchend)="onListingTouchEnd($event, listing)"
            >
              <h3 class="listing-title-featured">{{ listing.title }}</h3>
              <div class="listing-price-featured-card">
                <span class="price-currency-featured">{{
                  listing.currency || "€"
                }}</span>
                <span class="price-value-featured">{{
                  listing.price | number : "1.0-0"
                }}</span>
              </div>
              <div class="listing-meta-featured">
                <span class="meta-item">
                  <svg viewBox="0 0 24 24" class="meta-icon">
                    <path
                      d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                    ></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                  {{ listing.location }}
                </span>
                <span class="meta-item" *ngIf="listing.view_count">
                  <svg viewBox="0 0 24 24" class="meta-icon">
                    <path
                      d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                    ></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                  {{ listing.view_count }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="!isLoadingFeatured && featuredListings.length === 0"
        class="empty-listings-message"
      >
        <svg viewBox="0 0 24 24" class="empty-icon">
          <circle
            cx="12"
            cy="12"
            r="10"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          />
          <line
            x1="12"
            y1="7"
            x2="12"
            y2="13"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <circle cx="12" cy="16.5" r="1" fill="currentColor" />
        </svg>
        <p>No featured listings available at the moment.</p>
      </div>
      <a routerLink="/featured" class="view-all-link-prominent">
        View All Featured
        <svg viewBox="0 0 24 24" class="arrow-icon">
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </a>
    </section>

    <section class="recents-listings-section">
      <div class="section-header-recent">
        <div class="section-title-wrapper">
          <h2 class="section-title-large">Recently Added</h2>
          <p class="section-subtitle">Fresh listings added by our community</p>
        </div>
      </div>

      <div *ngIf="isLoadingRecent" class="recent-grid">
        <div
          class="listing-card-recent loading-placeholder"
          *ngFor="let i of [1, 2, 3, 4]"
        >
          <div class="listing-image-placeholder-recent"></div>
          <div class="listing-content">
            <div class="loading-line loading-title"></div>
            <div class="loading-line loading-category"></div>
            <div class="loading-line loading-price"></div>
          </div>
        </div>
      </div>

      <div
        *ngIf="!isLoadingRecent && recentListings.length > 0"
        class="recent-grid"
      >
        <div
          *ngFor="let listing of recentListings"
          class="listing-card-recent"
          (mouseenter)="onListingHover(listing)"
          (mouseleave)="onListingLeave(listing)"
        >
          <div
            class="listing-image-container-recent"
            (touchstart)="onTouchStart($event, listing)"
            (touchmove)="onTouchMove($event, listing)"
            (touchend)="onTouchEnd($event, listing)"
          >
            <div class="image-wrapper" [class.loading]="listing.isImageLoading">
              <img
                [src]="listing.image"
                [alt]="listing.title"
                class="listing-image-recent"
                loading="lazy"
                (load)="onImageLoad(listing.image, listing)"
                (error)="
                  listing.image =
                    '/assets/images/listing-placeholder/no-image-placeholder.png'
                "
              />

              <div class="image-loading-overlay" *ngIf="listing.isImageLoading">
                <div class="spinner"></div>
              </div>
            </div>

            <div
              class="image-click-zones desktop-only"
              *ngIf="hasMultipleImages(listing)"
            >
              <div
                class="click-zone zone-left"
                (click)="onImageZoneClick($event, listing, 'prev')"
                [attr.aria-label]="'Previous image'"
              >
                <div class="zone-icon">
                  <svg viewBox="0 0 24 24" class="zone-svg">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </div>
              </div>
              <div
                class="click-zone zone-middle"
                (click)="onImageZoneClick($event, listing, 'view')"
              ></div>
              <div
                class="click-zone zone-right"
                (click)="onImageZoneClick($event, listing, 'next')"
                [attr.aria-label]="'Next image'"
              >
                <div class="zone-icon">
                  <svg viewBox="0 0 24 24" class="zone-svg">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </div>
              </div>
            </div>

            <div
              class="carousel-controls recent-carousel desktop-only"
              *ngIf="hasMultipleImages(listing) && listing.showCarouselControls"
              [class.fading-out]="!listing.showCarouselControls"
            >
              <div class="carousel-indicator">
                <svg viewBox="0 0 24 24" class="carousel-icon">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </div>

              <div class="carousel-indicator">
                <svg viewBox="0 0 24 24" class="carousel-icon">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </div>

            <div
              class="image-counter recent-counter desktop-only"
              *ngIf="hasMultipleImages(listing)"
            >
              {{ getImageCounter(listing) }}
            </div>

            <div
              class="image-dots mobile-only"
              *ngIf="hasMultipleImages(listing)"
            >
              <span
                *ngFor="let img of listing.images; let i = index"
                class="dot"
                [class.active]="i === listing.currentImageIndex"
              ></span>
            </div>
          </div>

          <div
            class="listing-content-recent"
            (click)="onListingClick(listing)"
            (touchstart)="onListingTouchStart($event, listing)"
            (touchmove)="onListingTouchMove($event, listing)"
            (touchend)="onListingTouchEnd($event, listing)"
          >
            <h3 class="listing-title-recent">{{ listing.title }}</h3>

            <div class="recent-header">
              <div class="listing-price-recent">
                <span class="price-currency">{{
                  listing.currency || "€"
                }}</span>
                <span class="price-value">{{
                  listing.price | number : "1.0-0"
                }}</span>
              </div>
            </div>

            <div class="listing-details-recent">
              <div class="detail-row">
                <svg viewBox="0 0 24 24" class="detail-icon-small">
                  <path
                    d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                  ></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span class="detail-text">{{ listing.location }}</span>
                <span class="meta-item" *ngIf="listing.view_count">
                  <svg viewBox="0 0 24 24" class="meta-icon">
                    <path
                      d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                    ></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                  {{ listing.view_count }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="!isLoadingRecent && recentListings.length === 0"
        class="empty-listings-message"
      >
        <svg viewBox="0 0 24 24" class="empty-icon">
          <circle
            cx="12"
            cy="12"
            r="10"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          />
          <line
            x1="12"
            y1="7"
            x2="12"
            y2="13"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <circle cx="12" cy="16.5" r="1" fill="currentColor" />
        </svg>
        <p>No recent listings available at the moment.</p>
      </div>
      <div *ngIf="!isLoadingRecent && recentListings.length > 0">
        <a routerLink="/recent" class="view-all-link-prominent-recent">
          View All Recent
          <svg viewBox="0 0 24 24" class="arrow-icon">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </a>
      </div>
    </section>

    <section class="value-props-section">
      <div class="value-props-grid">
        <div class="value-prop">
          <div class="value-prop-icon-container">
            <svg
              viewBox="0 0 24 24"
              class="value-prop-icon"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <circle cx="9" cy="10" r="1" />
              <circle cx="15" cy="10" r="1" />
              <path d="M8 14c1.2 1.5 2.6 2.2 4 2.2s2.8-.7 4-2.2" />
            </svg>
          </div>
          <h3 class="value-prop-title">Safe & Secure</h3>
          <p class="value-prop-description">
            Our secure payment system and verification process protects the
            sellers.
          </p>
        </div>
        <div class="value-prop">
          <div class="value-prop-icon-container">
            <svg viewBox="0 0 24 24" class="value-prop-icon">
              <path d="M12 2v4"></path>
              <path d="M12 18v4"></path>
              <path d="M4.93 4.93l2.83 2.83"></path>
              <path d="M16.24 16.24l2.83 2.83"></path>
              <path d="M2 12h4"></path>
              <path d="M18 12h4"></path>
              <path d="M4.93 19.07l2.83-2.83"></path>
              <path d="M16.24 7.76l2.83-2.83"></path>
            </svg>
          </div>
          <h3 class="value-prop-title">Easy to Use</h3>
          <p class="value-prop-description">
            Whether you're searching or selling, our platform makes the process
            simple and efficient.
          </p>
        </div>
        <div class="value-prop">
          <div class="value-prop-icon-container">
            <svg viewBox="0 0 24 24" class="value-prop-icon">
              <path
                d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
              ></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
          </div>
          <h3 class="value-prop-title">Support</h3>
          <p class="value-prop-description">
            Our customer service team is always available to help with any
            issues or questions.
          </p>
        </div>
        <div class="value-prop">
          <div class="value-prop-icon-container">
            <svg
              fill="currentColor"
              height="24px"
              width="24px"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 310.75 310.75"
              xml:space="preserve"
            >
              <path
                d="M183.815,265.726c-32.444,0-60.868-21.837-76.306-54.325h102.101v-45.023H95.643c-0.284-3.642-0.437-7.29-0.437-11.016
        c0-3.691,0.152-7.384,0.437-10.977h113.969V99.353H107.51c15.438-32.485,43.861-54.315,76.306-54.315
        c31.01,0,60.21,20.759,76.2,54.152l40.626-19.418C277.091,30.554,232.329,0,183.815,0c-36.47,0-70.51,16.665-95.851,46.966
        C75.219,62.209,65.481,79.995,59.079,99.353H10.108v45.031h40.39c-0.217,3.617-0.329,7.311-0.329,10.977
        c0,3.704,0.112,7.351,0.329,11.016h-40.39V211.4h48.971c6.402,19.356,16.14,37.122,28.886,52.351
        c25.341,30.303,59.381,46.999,95.851,46.999c48.515,0,93.275-30.550,116.826-79.767l-40.626-19.454
        C244.025,244.965,214.825,265.726,183.815,265.726z"
              />
            </svg>
          </div>
          <h3 class="value-prop-title">Affordable Pricing</h3>
          <p class="value-prop-description">
            Get the best value for your money with competitive and transparent
            pricing.
          </p>
        </div>
      </div>
    </section>
  </main>

  <app-footer></app-footer>
  <app-floating-chat-button></app-floating-chat-button>
  <app-tutorial #tutorial *ngIf="shouldShowTutorialComponent"></app-tutorial>
</div>
